export interface IQrServerLogFiltersData {
    types: string[];
    codes: string[];
}

export default class QrServerLogFiltersData {
    public types: string[];
    public codes: string[];

    constructor(data: IQrServerLogFiltersData) {
        this.types = data.types;
        this.codes = data.codes;
    }

    public clone(): QrServerLogFiltersData {
        return new QrServerLogFiltersData({
            types: [...this.types],
            codes: [...this.codes]
        });
    }

    public toJson(buildingId: string, page?: number, perPage?: number): Record<string, string> {
        const payload: Record<string, string> = {
            buildings: buildingId
        };

        if (this.types.length > 0) payload.types = this.types.join(",");
        if (this.codes.length > 0) payload.codes = this.codes.join(",");
        if (page !== undefined) payload.page = page.toString();
        if (perPage !== undefined) payload.per_page = perPage.toString();

        return payload;
    }
}
